import React from 'react';
import newimage from "../assets/newimage.png";
import Headingcomp from '../components/Headingcomp';
import Clients from '../components/Clients';
import AnimateInView from '../components/AnimateInView';
import Newscomp from '../components/Newscomp';
import Aboutuscomp from '../components/Aboutuscomp';
import Approach2 from '../components/Approach2';
import Talk from '../components/Talk';
import newitemimage from "../assets/newitem1.jpg"
import { Helmet } from 'react-helmet';
const About = () => {
  return (
    <div>
      <Helmet>
              <title>About Dhiman Wood Works | Traditional Craftsmanship</title>
              <meta name="description" content="Learn about our legacy in woodworking and commitment to quality craftsmanship at Dhiman Wood Works." />
            </Helmet>
     <Headingcomp
                    heading="ABOUT US."
                    subheading="CRAFTING HOMES FOR MODERN LIVING"
                    image={newitemimage}
                />
                <AnimateInView delay={0.2}>
                  <Approach2/>
                </AnimateInView>
                      <AnimateInView delay={0.2}>
                <Clients/>
            </AnimateInView>
            <AnimateInView delay={0.2}>
                <Newscomp/>
            </AnimateInView>
            <AnimateInView delay={0.2}>
            <Aboutuscomp/>
            </AnimateInView>
            <AnimateInView delay={0.2}>
           <Talk/>
            </AnimateInView>
    </div>
  );
};
export default About;